<template>
	<section>
		<!-- <div class="tips">温馨提示：<b>您访问的是香港地区网站，投资有风险，入市需谨慎</b></div> -->
		<section class="top">
			<div class="flex">
				<router-link to="/">
					<img src="../img/logo99.png" class="logo" alt="金盛盈富">
				</router-link>
				<div class="font0">
					<span class="entry bgLive">
						<a
							href="http://www.golday666.com/mobile.php?fTag=1"
							onclick="ga ('send','event','m_index',' live ','content_first');"
							target="_blank">
							直播间
						</a>
					</span>
					<!-- 2025年11月3日 新增！ -->
					<span class="entry bg800"> <a
							href="https://vip.golday99.com/Apps/kefu_redirect?mobile=h5"
							onclick="ga ('send','event','m_index',' chat_live800 ','content_first');"
							target="_blank"> 客服 </a></span>

					<!-- 2025年11月3日 新增！ -->
					 <!-- 2026年2月24日 隐藏 -->
					<!-- <span class="entry bg800 position-relative" @click="showChat=!showChat">
						客服
						<div class="zb_pop" v-show="showChat">
							<img @click="helpChat(0)" class="dykf_img" src="../img/sj_shouye_jishidaoyi.png" alt="">
							<img @click="helpChat(1)" class="zrkf_img" src="../img/sj_shouye_zhenren1V1.gif" alt="">
						</div>
					</span> -->
					<span class="entry bgLogin">
						<a
							href="https://vip.goldayjs.com/Mobile/Index/login.html"
							onclick="ga ('send','event','m_index',' login ','content_first');"
							target="_blank">
							存取款登录
						</a>
					</span>
				</div>
			</div>
		</section>
	</section>
</template>

<script>
	export default {
		name: 'top',
		data() {
			return {
				showChat: false,
			}
		},
		methods: {
			// 2025年11月3日 新增！
			helpChat(type) {
				// this.showChat = false;
				if(type == 0) {
					window.open('https://vip.golday99.com/Apps/kefu_redirect?mobile=h5', '_self');
				} else {
					// 测试环境
					// window.open('https://zhibo-dev.jsjs047.com/mobile_liveCustomerService.php?fTag=1', '_blank');
					// 线上环境
					window.open('https://live.golday888.com.cn/mobile_liveCustomerService.php?fTag=1', '_blank');
				}
			}
		}
	}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 2025年11月3日 新增！ */
.dykf_img {
	display: block;
	width: 1.4rem;
}

.zrkf_img {
	display: block;
	width: 2.07rem;
}

.zb_pop {
	position: absolute;
	width: 2.6rem;
	height: 1.7rem;
	background: url('../img/sj_shouye_waikuang.png') no-repeat center center;
	background-size: 100% 100%;
    right: -1rem;
    z-index: 2;
    top: .65rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.35rem;
}

.position-relative {
	position: relative;
}

.tips {
	font-size: 0.24rem;
	padding: 0.15rem 0 0.15rem 0.3rem;
	background: #fff;
	box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}

.tips b {
	font-size: 0.24rem;
	color: red;
}

.top {
	width: 100%;
	box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
	/* 2026年2月9日 2026新年背景图 */
	background:#fff url("../img/newyear.png")no-repeat  center;
	/* background: #fff; */
	background-size: cover;
}

.top .flex {
	width: 100%;
	height: 1rem;
	/* background-color: #ffffff;	 */
	padding: 0 0.3rem;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
}

.entry {
	padding: 0 0.1rem 0 0.4rem;
	height: 0.56rem;
	line-height: 0.56rem;
	border-radius: 5px;
	font-size: 0.24rem;
	border: 1px solid #666;
	margin-left: 0.1rem;
}

.active {
	height: 1rem;
	line-height: 0.9rem;
}

.logo {
	width: 2.25rem;
}

.font0 {
	font-size: 0;
}

.bgLive {
	background: url('../img/live.gif') no-repeat left center;
	/* background: url("../img/live.png")no-repeat left center; */
	background-size: 0.6rem 0.6rem;
	padding-left: 0.6rem;
	color: red;
	border: 1px solid red;
}

.bg800 {
	background: url('../img/bg800.png') no-repeat left 0.1rem center;
	background-size: 0.27rem 0.28rem;
}

.bgLogin {
	background: url('../img/bgLogin.png') no-repeat left 0.1rem center;
	background-size: 0.24rem 0.24rem;
}
</style>



// WEBPACK FOOTER //
// src/components/header/components/Top.vue